module.exports = __webpack_public_path__ + "img/LINK.4b117012.png";